import React, { Component } from "react";
import './styles.scss';
import Utils from "../../../../../utils/Utils";
import ButtonPrimary from "../../ButtonPrimary";
import { setInitialFocus } from "src/utils/Utils";
import { handleClickRegistraCorreo } from "../../utilsLandingTelmex";
class SectionOperation extends Component {
    componentDidMount() {
        setInitialFocus('.landing-telmex__button-primary--register-operation');
    }
    render() {
        const { localAssets, localTranslations } = this.props;

        return (
            <div className="landing-telmex__section-operation">
                <img
                    className="landing-telmex__logo landing-telmex__logo--operation"
                    src={localAssets.get('landing_logo_clarotvplus')}
                    alt=""
                />
                <div className="landing-telmex__title landing-telmex__title--part-1">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte1'), 32)}
                </div>
                <div className="landing-telmex__title landing-telmex__title--part-2">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte2'), 32)}
                </div>
                <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-1">
                    {Utils.cutPlayerString(localTranslations.get('landingoperaciones_paginaprincipal_seccion1_texto1_parrafo1'), 38)}
                </div>
                <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-2">
                    {Utils.cutPlayerString(localTranslations.get('landingoperaciones_paginaprincipal_seccion1_Texto2_Parrafo1'), 38)}{' '}
                </div>
                <div className="landing-telmex__buttons-container">
                    <ButtonPrimary
                        className="landing-telmex__button-primary--register-operation"
                        title={Utils.cutPlayerString(localTranslations.get('landing_boton_texto_creatucuenta'), 25)}
                        onClick={() => handleClickRegistraCorreo(this.props)}
                    />
                </div>
            </div>
        )
    }
}

export default SectionOperation;



// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/components/SectionOperation/index.jsx